import React from "react"
import autobind from "class-autobind"
import Dialog from "material-ui/Dialog"
import TextField from "material-ui/TextField"
import FlatButton from "material-ui/FlatButton"
import strings from "../../localization/strings"
import Clear from "../../components/misc/Clear"
import CircularProgress from "material-ui/CircularProgress"
import { Table, TableBody, TableFooter, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from "material-ui/Table"
import FontIcon from "material-ui/FontIcon"
import IconButton from "material-ui/IconButton"
import ImageLoader from "../misc/ImageLoader"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import { IEquipmentDocument } from "../../models"
import * as api from "../../api"
import AccountStore from "../../stores/AccountStore"
interface IProps {
    open: boolean
    handleClose(): void
    handleAddEquipmentList(equipments: IEquipmentDocument[]): void
}
interface IState {
    equipmentList: IEquipmentDocument[]
    search: string
    offset: number
    loading: boolean
    total: number
    selectedEquipmentList: IEquipmentDocument[]
}

export default class AddEquipmentDialogForChip extends React.Component<IProps, IState>  {
    private limit: number
    constructor(props) {
        super(props)
        this.state = {
            equipmentList: [],
            search: "",
            offset: 0,
            loading: true,
            total: 0,
            selectedEquipmentList: []
        }
        autobind(this)
        const tempLimit = Math.floor(window.innerHeight / 50) - 9
        this.limit = tempLimit > 8 ? 8 : tempLimit
    }

    componentDidMount() {
        this.getEquipmentList()
    }

    getEquipmentList() {
        const { offset, search } = this.state
        api.getEquipmentList(AccountStore.getCurrentAccount().Id, "", offset / this.limit, this.limit, search).then(res =>
            this.setState({
                equipmentList: res.data.Documents,
                total: res.data.TotalDocumentCount,
                loading: false
            })
        )
    }

    handleSearchChange(e) {
        this.setState(
            {
                search: e.target.value,
                offset: 0,
                loading: true,
                selectedEquipmentList: []
            },
            () => {
                this.getEquipmentList()
            }
        )
    }

    onFirstClick() {
        this.offsetChange(0)
    }

    onLastClick() {
        const { total } = this.state
        const { limit } = this
        if (total % limit === 0) {
            this.offsetChange(total - limit)
        } else {
            this.offsetChange(total - (total % limit))
        }
    }

    onPrevClick() {
        this.offsetChange(this.state.offset - this.limit)
    }

    onNextClick() {
        this.offsetChange(this.state.offset + this.limit)
    }

    offsetChange(offset) {
        this.setState(
            {
                offset,
                loading: true,
                selectedEquipmentList: []
            },
            () => {
                this.getEquipmentList()
            }
        )
    }

    handelOnCellClick(rowNumber) {
        //---- if equipment is array, we can use this code ----
        // const equipmentList = this.state.equipmentList.slice();
        // const pickeddEquipment = equipmentList[rowNumber];
        // let selectedEquipmentList = this.state.selectedEquipmentList.slice();
        // if (selectedEquipmentList.indexOf(pickeddEquipment) === -1) {
        //   selectedEquipmentList.push(pickeddEquipment);
        // }
        // else {
        //   selectedEquipmentList.splice(selectedEquipmentList.indexOf(pickeddEquipment), 1);
        // }
        // this.setState({
        //   selectedEquipmentList,
        // })

        //---- only one equipment
        const equipmentList = this.state.equipmentList.slice()
        this.setState({
            selectedEquipmentList: [equipmentList[rowNumber]]
        })
    }

    allRowsSelection(value) {
        if (value === "all") {
            this.setState({
                selectedEquipmentList: this.state.equipmentList.slice()
            })
        } else if (value === "none") {
            this.setState({
                selectedEquipmentList: []
            })
        }
    }

    handleAddEquipmentList() {
        this.props.handleAddEquipmentList(this.state.selectedEquipmentList)
    }

    render() {
        const { equipmentList, loading, search, total, offset, selectedEquipmentList } = this.state
        const { limit } = this
        const actions = [
            <FlatButton data-intercom-target={"Btn-Close-Equipment-Selection-Dialog"} label={strings.Cancel} secondary onClick={this.props.handleClose} />,
            <FlatButton data-intercom-target={"Btn-Save-Selected-Equipment"} label={strings.OK} primary={true} keyboardFocused={true} onClick={this.handleAddEquipmentList} />
        ]
        return (
            <Dialog title={strings.Choose_Equipment} actions={actions} modal={true} open={this.props.open} onRequestClose={this.props.handleClose}>
                <div style={{ padding: 20, paddingLeft: 35 }}>
                    <i style={{ fontSize: 25 }} className="fa fa-search" />
                    <TextField hintText={strings.search} value={search} onChange={this.handleSearchChange} style={{ marginRight: 20, width: "90%", marginLeft: 15 }} />
                    <Clear />
                </div>
                <div data-intercom-target={"Equipment-Selection-Dialog"} style={{ textAlign: "center", height: 500 }}>
                    {loading ?
                        <CircularProgress /> :
                        <Table onCellClick={this.handelOnCellClick} onRowSelection={this.allRowsSelection} multiSelectable={false}>
                            <TableHeader>
                                <TableRow className="ShortSelectBoxTableHeader">
                                    <TableHeaderColumn style={{ width: 30, textAlign: "center" }} />
                                    <TableHeaderColumn style={{ width: 100, textAlign: "center" }}>{strings.Id}</TableHeaderColumn>
                                    <TableHeaderColumn style={{ width: 100, textAlign: "center" }}>{strings.Name}</TableHeaderColumn>
                                    <TableHeaderColumn >{strings.Home_Hierarchy}</TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody showRowHover={true} deselectOnClickaway={false}>
                                {equipmentList.map((row, i) => {
                                    let smallImage
                                    if (row.ImageS3Url) {
                                        smallImage = <ImageLoader url={row.ImageS3Url} fixedHeight={75} avatar={true} src={"/users/profileimage/" + row.ImageS3Url} key={`smallImg-${i}`} />
                                    }
                                    const homeHierarchyName = hierarchyHelper.getFullyQualifiedLevelNameById(row.DefaultHierarchyItemId)
                                    return (
                                        <TableRow key={row.Id} selected={selectedEquipmentList.indexOf(row) > -1} className="ShortSelectBoxTableRow">
                                            <TableRowColumn style={{ width: 30, textAlign: "center" }}>{smallImage}</TableRowColumn>
                                            <TableRowColumn style={{ width: 100, textAlign: "center", cursor: "pointer" }}>{row.ExternalId}</TableRowColumn>
                                            <TableRowColumn style={{ width: 100, textAlign: "center", cursor: "pointer" }}>{row.Name}</TableRowColumn>
                                            <TableRowColumn style={{ cursor: "pointer" }} title={homeHierarchyName !== strings.Hierarchy_Removed && hierarchyHelper.getFullPathLabel(row.DefaultHierarchyItemId)}>
                                                {homeHierarchyName}
                                            </TableRowColumn>
                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                            <TableFooter>
                                <TableRow className="TableFooter" style={{ borderBottom: 0 }}>
                                    <TableRowColumn style={{ float: "right" }}>
                                        <IconButton disabled={offset === 0} onClick={this.onFirstClick}>
                                            <FontIcon className="fa fa-step-backward" />
                                        </IconButton>
                                        <IconButton disabled={offset === 0} onClick={this.onPrevClick}>
                                            <FontIcon className="fa fa-chevron-left" />
                                        </IconButton>
                                        <IconButton disabled={offset + limit >= total} onClick={this.onNextClick}>
                                            <FontIcon className="fa fa-chevron-right" />
                                        </IconButton>
                                        <IconButton disabled={offset + limit >= total} onClick={this.onLastClick}>
                                            <FontIcon className="fa fa-step-forward" />
                                        </IconButton>
                                    </TableRowColumn>
                                </TableRow>
                            </TableFooter>
                        </Table>
                    }
                </div>
            </Dialog>
        )
    }
}